<template>
  <q-dialog
    :visible="isVisible"
    title="新增"
    width="400px"
    :innerScroll="false"
    :showFooter="false"
    @close="onCancel"
  >
    <el-form ref="formRef" :model="form" label-width="100px" :rules="rules" size="small">
      <el-form-item label="品类:" prop="category">
        <el-select v-model="form.category" filterable placeholder="请选择" style="width: 100%">
          <el-option v-for="item in optionData.categoryAll" :key="item.content" :label="item.content" :value="item.content"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onConfirm" :loading="loading">确认</el-button>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'AddDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    optionData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  data() {
    return {
      loading: false,
      form: {
        category: ''
      },
      rules: {
        category: [{ required: true, message: '请选择品类', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form = { category: '' }
      }
    }
  },
  methods: {
    onCancel() {
      this.form = { category: '' }
      this.$refs.formRef && this.$refs.formRef.clearValidate()
      this.isVisible = false
    },
    onConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        
        this.loading = true
        let data = {
          category: '',
          saleLocationId: '0',
          productTypeId: '0'
        }
        this.$q.newProduct
          .assessmentRulesList({ data: data })
          .then((res) => {
            let addTableData = res.data
            let tableData = JSON.parse(JSON.stringify(addTableData)).slice(0, 13)
            tableData.forEach((v, index) => {
              tableData[index].category = this.form.category
              tableData[index].limitLower = ''
              tableData[index].limitUpper = ''
              tableData[index].ruleDesc = ''
            })
            this.$emit('confirm', tableData)
            this.isVisible = false
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.dialog-footer
  text-align center
  padding 15px 0
</style>
